var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"progress-number font-weight-bold border--text",style:(_vm.styleNumber)},[_vm._v(" "+_vm._s(_vm.progress)+" ")]),_c('div',{staticClass:"progress-linear",style:(_vm.styleLinear)})])}
var staticRenderFns = []

export { render, staticRenderFns }